<template>
    <div id="account-input">
        <div class="input-container">
            <div class="input-box">
                <input
                    id="accountInput"
                    type="text"
                    :maxlength="30"
                    :placeholder="$t('tips.Please_enter_email_address')"
                    v-model="userName"
                    @input="onInput()"
                    @focus="focusEvent(true)"
                    @blur="focusEvent(false)"
                />
            </div>
            <div class="quickdel" @click="quickdel" v-show="showdel">
                <i class="reddel ico ico-redx"></i>
            </div>
        </div>
        <div class="tips" v-show="isErrMsg">
            <div class="input-error">{{ message }}</div>
        </div>
    </div>
</template>
<script>
import tools from "../../utils/fun";
export default {
    components: {},
    props: ["gamePanelShow"],
    data() {
        return {
            message: "",
            isErrMsg: false,
            userName: "",
            isFocus: false,
            showdel: true,
            isOk: false,
            maxLength: "",
            maxlength: 10,
        };
    },
    mounted() {},
    methods: {
        showError(error) {
            this.message = error;
            this.isErrMsg = true;
            this.isOk = false;
        },
        onInput() {
            this.userName = this.userName.trim();
            this.showdel = true;
            this.message = "";
            this.isErrMsg = false;
            this.$emit("check-event");
        },
        quickdel() {
            this.userName = "";
            this.showdel = true;
            this.message = "";
            this.isErrMsg = false;
        },

        focusEvent(e) {
            this.isFocus = e;
            if (!this.isFocus) this.$emit("check-event");

            if (this.isFocus) {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(-30%)";
            } else {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(0%)";
            }
            this.checkAccount();
        },
        verifyEmail() {
            var email = this.userName;
            if (email && email.indexOf("@") != -1) {
                return true;
            } else {
                return false;
            }
            // var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            // if (reg.test(email)) {
            //     return true;
            // } else {
            //     return false;
            // }
        },
        checkAccount() {
            if (this.userName == "") {
                this.message = this.$t("tips.email_address_is_required");
                this.isErrMsg = true;

                this.isOk = false;
                return;
            }
            if (!this.verifyEmail()) {
                this.message = this.$t("tips.Please_enter_right_email_address");
                this.isErrMsg = true;

                this.isOk = false;
                return;
            }
            this.isOk = true;
        },
        focusInput(id) {
            document.getElementById(id).focus();
        },
    },
    watch: {},
};
</script>
<style >
@import "../../assets/css/login.css";
#account-input {
    position: relative;
    width: 580px;
    height: 82px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/input_user_name.vue